/*globals $*/
'use strict';

const getValidationFunctions = () => import("./validate");

import formFunctions from '../../../library/100x100/validation/formFunctions';
const formFuncs = new formFunctions("hundreds-validation__input_error", "hundreds-validation__input_success");

$( document ).ready(function() {

    $('#hundreds__contact-form #hundreds__contact_submit-button').on('click', function(e){
        //console.log('contact');
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateContactForm();
        });
    });

    /*$('#hundreds__newsletter-form #hundreds__newsletter_submit-button').on('click', function(e){
        console.log('newsletter');
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateNewsletterForm();
        });
    });*/

    /* Logic to select the form from the main selector. There are 9 forms partially hidden. */

    var form = $('#hundreds__contact-form');
    var formSelector= $("#form-selector");
    let preselection = formSelector.data('value'); 

    if ( preselection != 0 ) {
        changeToSelection(preselection);
        //formSelector.val(preselection).change();
    }
    
    // activate form depending on the main select
    formSelector.on("change", function () {
        let chosen = $(this).val();
        changeToSelection(chosen);
    });

    function changeToSelection(selection) {
        if (selection == 0) {
            $("#complete-form").addClass('hidden');
        } else {
            $("#complete-form").removeClass('hidden');
            
            for (var i = formSelector.children('option').length - 1; i >= 1; i--) {
                $("#form-selection-"+i).addClass('hidden');
            }
            $("#form-selection-"+selection).removeClass('hidden');
        }
        formFuncs.cleanForm(form);
        // clean also the messages
        $('#hundreds__contact-form #hundreds__messages').removeClass("hundreds__messages--show").addClass("hundreds__messages--hide");
        $('#hundreds__contact-form #hundreds__messages__send-ok').removeClass("hundreds__messages--show").addClass("hundreds__messages--hide");
        $('#hundreds__contact-form #hundreds__messages__send-ko').removeClass("hundreds__messages--show").addClass("hundreds__messages--hide");
        $('#hundreds__contact-form #hundreds__messages__validation-ko').removeClass("hundreds__messages--show").addClass("hundreds__messages--hide");

        formSelector.val(selection); 
    }

    /* Adapt * required to the placeholder depending on the user choice */
    $("input[name='contact_preference']").on("change", function () {
        var placeholder_email = $('#hundreds__contact_email').attr('placeholder');
        var placeholder_phone = $('#hundreds__contact_phone').attr('placeholder');

        if ($(this).val() === 'Email') {
            if ( !placeholder_email.includes('*') ) {
                $('#hundreds__contact_email').attr('placeholder', placeholder_email + '*');
            }
            if ( placeholder_phone.includes('*') ) {
                // Remove any trailing or embedded * (adjust regex as needed)
                placeholder_phone = placeholder_phone.replace(/\s*\*+$/, ''); // removes " *" at the end
                $('#hundreds__contact_phone').attr('placeholder', placeholder_phone);
            }
        }
        if ($(this).val() === 'Telèfon') {
            if ( !placeholder_phone.includes('*') ) {
                $('#hundreds__contact_phone').attr('placeholder', placeholder_phone + '*');
            }
            if ( placeholder_email.includes('*') ) {
                // Remove any trailing or embedded * (adjust regex as needed)
                placeholder_email = placeholder_email.replace(/\s*\*+$/, ''); // removes " *" at the end
                $('#hundreds__contact_email').attr('placeholder', placeholder_email);
            }
        }
    });

    /* Activate visibility dependind of the choice of form1_factura_electrica  */
    $("input[name='form1_factura_electrica']").on("change", function () {
        //console.log( $(this).val() );
        if ($(this).val() == 'Si') {
            $("#form1_hide_factura_1").slideDown();
            $("#form1_hide_factura_2").slideUp();
        } else if ($(this).val() == 'No') {
            $("#form1_hide_factura_2").slideDown();
            $("#form1_hide_factura_1").slideUp();
        } else {
            $("#form1_hide_factura_1").slideUp();
            $("#form1_hide_factura_2").slideUp();
        }
    });

    /* Activate visibility dependind of the choice of form3_problemas[]  */
    $("#form3_problemas_8").on("change", function () {
        if ( $(this).is(':checked') ) {
            $("#form3_hide_problemas_1").slideDown();
        } else {
            $("#form3_hide_problemas_1").slideUp();
        }
    });
    /* Activate visibility dependind of the choice of form9_servicios[]  */
    $("input[name='form9_servicios']").on("change", function () {
        if ($(this).val() == 'Altre') {
            $("#form9_hide_servicios_1").slideDown();
        } else {
            $("#form9_hide_servicios_1").slideUp();
        }
    });



});

